export const meta = {
  id: 'O04', slug: 'papeis', title: 'Como funcionam os papéis',
  description: 'Entenda a diferença entre Aluno, Mentor e Owner e como a herança de acesso funciona.',
  profile: 'owner', category: 'pessoas', type: 'concept', status: 'published', order: 340,
  keywords: ['papéis', 'aluno', 'mentor', 'owner', 'permissões'], previous: 'O03', next: 'O05',
  related: ['O01', 'M00', 'A00'], updatedAt: '2026-08-17', appVersion: 'v1'
}

# Como funcionam os papéis

Os papéis definem a alçada de cada pessoa dentro do Personagrama.

- **Aluno / Mentorado:** acompanha o próprio desenvolvimento.
- **Mentor:** possui sua experiência de Aluno e acompanha mentorados vinculados.
- **Owner:** possui as camadas anteriores e administra o ambiente.

<Diagram kind="role-hierarchy" />

<Callout type="concept">A lógica é cumulativa: Aluno ⊂ Mentor ⊂ Owner.</Callout>

<Callout type="important">Ter papel de Mentor não libera automaticamente acesso a todos os alunos. A associação Mentor–Mentorado continua necessária.</Callout>
